import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ToastResponse } from '../../utilities/ToastResponse';
import { SliderCreate } from '../../services';

export const fetchSliderCreate = createAsyncThunk(
    'sliderCreate/fetchSliderCreate',
    async ({ file, title, slug, sliderGroupId, sort }) => {
        const response = await SliderCreate(file, title, slug, sliderGroupId, sort)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
)

const sliderCreateSlice = createSlice({
    name: 'sliderCreate',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSliderCreate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchSliderCreate.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchSliderCreate.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default sliderCreateSlice.reducer;
